import { RoleDto } from '@/api/base/model';

const CompanyAdminSystemKey = 'COMPANY_ADMIN';
const CompanyAdminWithHrStories = 'COMPANY_ADMIN_WITH_HR_STORIES';

export const isCompanyAdmin = (userRoles: Array<RoleDto>) =>
  userRoles.some(
    (role) =>
      role?.systemKey === CompanyAdminSystemKey || role?.systemKey === CompanyAdminWithHrStories,
  );
